import { NavLinks } from '@iveco-ti/iveco-ds'
import { ShieldBan } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router'
import { toast } from 'react-toastify'

import { Can } from '../components/Can'
import { Toast } from '../components/Toast'
import { ROUTES } from '../constants/routes'
import { usePermissions } from '../hooks/usePermissions'

export function SsoLayout() {
  const { t } = useTranslation('common')
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const { cannot } = usePermissions()

  const handleNavigate = (route: string) => {
    navigate(route)
  }

  if (cannot('access', 'Sso')) {
    toast(Toast, {
      toastId: 'sso_access_denied',
      data: {
        type: 'danger',
        icon: ShieldBan,
        title: t('access_denied.title'),
        description: t('access_denied.description'),
      },
    })

    return <Navigate to={ROUTES.PANEL.NEWS} replace />
  }

  return (
    <>
      <NavLinks.Root>
        <p className="text-lg text-brand-900 font-semibold mr-8">
          {t('sso_layout.title')}
        </p>

        <NavLinks.Link
          onClick={() => handleNavigate(ROUTES.SSO.ACCESS)}
          active={pathname === ROUTES.SSO.ACCESS}
        >
          {t('sso_layout.menus.access')}
        </NavLinks.Link>

        <Can I="access" a="Applications">
          <NavLinks.Link
            onClick={() => handleNavigate(ROUTES.SSO.APPLICATIONS)}
            active={pathname === ROUTES.SSO.APPLICATIONS}
          >
            {t('sso_layout.menus.applications')}
          </NavLinks.Link>
        </Can>

        <NavLinks.Link
          onClick={() => handleNavigate(ROUTES.SSO.ACCOUNTS)}
          active={pathname === ROUTES.SSO.ACCOUNTS}
        >
          {t('sso_layout.menus.accounts')}
        </NavLinks.Link>
      </NavLinks.Root>

      <Outlet />
    </>
  )
}
